import * as React from "react";
import { ActTagViewForPcGrid } from "./styles";

interface ActTagViewsProps {
	actTags: string[];
}

export const ActTagViewForPc = (props: ActTagViewsProps) => {
	const { actTags } = props;

	return (
		<ActTagViewForPcGrid>
			{(actTags || []).map((item, index) => (
				<img key={`${item}${index}`} src={item} />
			))}
		</ActTagViewForPcGrid>
	);
};
